import Vue from 'vue';
import PropertyCalendarService from '@/services/property-calendar';
import PropertyCalendarInputTransformer from '@/transformers/input/property-calendar';
import PropertyCalendarOutputTransformer from '@/transformers/output/property-calendar';

export default {
    namespaced: true,
    state: {
        entries: [],
        requestPending: false,
    },
    mutations: {
        setEntries: (state, entries) => {
            if (!Array.isArray(entries)) {
                return;
            }

            state.entries = entries;
        },
        addEntry: ({ entries }, entry) => {
            entries.push(entry);
        },
        rewriteEntry: ({ entries }, { entryId, data }) => {
            const index = entries.findIndex((entry) => entry.id === entryId);
            if (index >= 0) {
                Vue.set(entries, index, data);
            }
        },
        deleteEntry: ({ entries }, entryId) => {
            const index = entries.findIndex((entry) => entry.id === entryId);
            if (index >= 0) {
                Vue.delete(entries, index);
            }
        },
        setRequestPending: (state, requestPending) => {
            state.requestPending = Boolean(requestPending);
        },
    },
    actions: {
        getEntries: async ({ commit }, { propertyId = undefined } = {}) => {
            try {
                commit('setRequestPending', true);
                const response = await PropertyCalendarService.getEntries({ propertyId });
                const transformed = PropertyCalendarInputTransformer.transform(response.data);
                commit('setEntries', transformed);
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('setRequestPending', false);
            }
        },
        checkAvailability: async ({ commit }, { propertyId, entryId = null, startDate, endDate, termless }) => {
            try {
                commit('setRequestPending', true);
                const payload = {
                    propertyId,
                    startDate,
                    endDate: (termless || !endDate) ? undefined : endDate,
                    termless,
                    exceptEntries: entryId ? [entryId] : [],
                };
                const { data: { available } = {} } = await PropertyCalendarService.checkAvailability(payload);
                console.log('data:', available);
                
                return available;
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('setRequestPending', false);
            }
        },
        createEntry: async ({ commit }, payload) => {
            try {
                commit('setRequestPending', true);
                const response = await PropertyCalendarService.createEntry({
                    data: PropertyCalendarOutputTransformer.transform(payload),
                });
                const transformed = PropertyCalendarInputTransformer.transform([ response.data.entry ]);
                commit('addEntry', transformed[0]);
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('setRequestPending', false);
            }
        },
        rewriteEntry: ({ commit }, { entryId, payload }) => {
            commit('rewriteEntry', { entryId, data: payload });
        },
        updateEntry: async ({ commit }, { entryId, payload }) => {
            try {
                commit('setRequestPending', true);
                const response = await PropertyCalendarService.updateEntry({
                    entryId,
                    data: PropertyCalendarOutputTransformer.transform(payload),
                });
                const transformed = PropertyCalendarInputTransformer.transform([ response.data.entry ]);
                commit('rewriteEntry', { entryId, data: transformed[0] });
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('setRequestPending', false);
            }
        },
        deleteEntry: async ({ commit }, entryId) => {
            try {
                commit('setRequestPending', true);
                const response = await PropertyCalendarService.deleteEntry(entryId);
                if (!response.data.success) {
                    return;
                }
                commit('deleteEntry', entryId);
            }
            catch (error) {
                throw error;
            }
            finally {
                commit('setRequestPending', false);
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/vuex/property-calendar/index.js